import axios from "axios";
import { api } from "./api_route";

export const createInterimAwardsAPI = async (interimAwardsData) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      interimAwardsData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/interimAwards/create`,
      interimAwardsData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getInterimAwardsByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(`${api}/interimAwards/case/${caseID}`);
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateInterimAwardsAPI = async (
  interimAwards_ID,
  interimAwardsData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      interimAwardsData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/interimAwards/update/${interimAwards_ID}`,
      interimAwardsData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteInterimAwardsAPI = async (interimAwards_ID) => {
  try {
    const response = await axios.delete(
      `${api}/interimAwards/delete/${interimAwards_ID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};
